import { useRef, useState } from 'react'
import { MediaQuery, Row, Col, Container, Button } from 'UI'
import Layout from 'components/common/Layout'
import Core from '../Core'
import Header from '../Header'
import Objectives from '../Objectives'
import Prerequirements from '../Prerequirements'
import ConcernedAudiences from '../ConcernedAudiences'
import VideoPopUp from '../VideoPopUp'
import { ProfileTypes } from 'constants/'
import IntersectionComponent from 'components/common/IntersectionComponent'
import VideoThumbnail from '../Header/VideoThumbnail'
import Text from './text.json'
import EnterpriseOffer from '../EnterpriseOffer'
import LearningPathInfos from '../LearningPathInfos'
import BoostCareer from '../BoostCareer'
import { createUseStyles } from 'react-jss'
import style from './style'
import Pricing from '../Pricing'
import Tags from '../Tags'
import Categories from '../Categories'

const useStyle = createUseStyles(style)

export default ({
  loading,
  courses,
  ProfileType,
  PresentationVideoThumbnail
}) => {
  const { sideStyle, requirementAndAudience, pricing } = useStyle()
  const [forceRender, setForceRender] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const ref = useRef()
  const scrollToPricing = () => {
    setForceRender(true)
    setTimeout(() => {
      ref && ref.current && window.scrollTo({ top: window.scrollY + ref.current.getBoundingClientRect().top, behavior: 'smooth' })
    })
  }
  const allCoursesBought = courses.every(course => course.IsAccessible || course.IsFree)
  const notSubscribedUser = ProfileType ? ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.Buyer || ProfileType === ProfileTypes.FreeSubscriber : true
  const showPricing = notSubscribedUser && !allCoursesBought
  return (
    <>
      <Layout hideSupport>
        <Container>
          <Row>
            <Col grid={8} direction='column' gap={24}>
              <Header
                showPricing={showPricing}
                onVideoThumbnailClick={() => setShowPopUp(true)}
                scrollToPricing={scrollToPricing}
              />
              <Core scrollToPricing={scrollToPricing} />
            </Col>
            <Col grid={4} direction='column' gap={24} className={sideStyle}>
              <MediaQuery ShowOnDesktop>
                <Row repeatCols={1} gap={12}>
                  <div style={{
                    minHeight: 84,
                    marginTop: 34
                  }}
                  >
                    {!loading && PresentationVideoThumbnail ? (<VideoThumbnail onVideoThumbnailClick={() => setShowPopUp(true)} />) : null}
                  </div>
                  {showPricing
                    ? <Button
                        key={`${Text.accessToTheLearningPath}-${loading}`}
                        loading={loading}
                        label={Text.accessToTheLearningPath}
                        width='100%'
                        height={54}
                        onHandleClick={() => scrollToPricing()}
                      />
                    : null}
                </Row>
              </MediaQuery>
              <BoostCareer noFlex />
              <EnterpriseOffer loading={loading} noMargin noFlex />
              <LearningPathInfos loading={loading} />
              <Categories />
              <Tags />
            </Col>
          </Row>
          <IntersectionComponent component={Objectives} />
          <IntersectionComponent component={() => (
            <div className={requirementAndAudience}>
              <Prerequirements />
              <ConcernedAudiences />
            </div>
          )}
          />
          <Row className={pricing} repeatCols={1}>
            <IntersectionComponent
              forceRender={forceRender} component={() =>
                showPricing
                  ? (
                    <>
                      <div ref={ref} />
                      <Pricing />
                    </>)
                  : null}
            />
          </Row>
        </Container>
      </Layout>
      <VideoPopUp
        showPricing={showPricing}
        showPopUp={showPopUp}
        setShowPopUp={setShowPopUp}
        onAccessLearningPathClick={scrollToPricing}
      />
    </>
  )
}
